import {Component} from '@angular/core';
import {Compbaser} from "../../../components/compbaser/compbases";

@Component({
    selector: 'app-station-loader',
    styleUrls: ['station-loader.component.scss'],
    templateUrl: 'station-loader.component.html',
    standalone: false
})
export default class StationLoaderComponent extends Compbaser {
    usersFactory = () => import('../station-component/station.component');
    constructor() {
        super();
    }
}

